import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=189de798"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports